import { createSlice } from '@reduxjs/toolkit';
import { IDictListParam } from '../interface/IDict';

export interface IDictState {
    dictParams: IDictListParam;
}

const initialState: IDictState = {
    dictParams: {},
};

export const dictSlice = createSlice({
    name: 'dictSlice',
    initialState: initialState,
    reducers: {
        setDictParams: (state, action) => {
            state.dictParams = action.payload;
        },
    },
});

export const { setDictParams } = dictSlice.actions;

export default dictSlice.reducer;
